// Module
var code = "<span class=\"text-before\">{{textBefore}}</span>\n<i ng-class=\"attr.checkedIcon\" class=\"checked\"></i>\n<i ng-class=\"attr.uncheckedIcon\" class=\"unchecked\"></i>\n<i ng-class=\"attr.partialIcon\" class=\"indeterminate\"></i>\n<span class=\"text-after\">{{textAfter}}</span>";
// Exports
module.exports = code;